import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=4c7079ae&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=4c7079ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7079ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c7079ae')) {
      api.createRecord('4c7079ae', component.options)
    } else {
      api.reload('4c7079ae', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=4c7079ae&scoped=true&", function () {
      api.rerender('4c7079ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fnh8Ndvy0N7K/JS/comp/Voucher.vue"
export default component.exports